import ShipmentImportDialog from '@/components/order/ShipmentImportDialog.vue';
import { beginPositionRead } from '@/utils/positionReadSequence';

// Notify.vue supports legacy HTML messages; never interpolate raw API/Excel text there.
const escapeText = value => String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));

export default {
  components: { ShipmentImportDialog },
  data: () => ({
    showShipmentImport: false,
    shipmentScope: { page: 'positions' },
    shipmentNotice: '',
    shipmentRefreshing: false,
    shipmentPageActive: true,
    shipmentCompletedAttempts: new Set(),
  }),
  beforeRouteLeave() {
    this.shipmentPageActive = false;
    this.showShipmentImport = false;
    beginPositionRead();
  },
  beforeUnmount() { this.shipmentPageActive = false; },
  watch: {
    '$route.params.id'(id, previousId) {
      if (id !== previousId) { this.showShipmentImport = false; this.shipmentNotice = ''; }
    },
  },
  methods: {
    openShipmentImport() {
      if (!this.canImportShipment) return;
      this.shipmentScope = this.$route.params.id
        ? { page: 'order', orderId: this.$route.params.id }
        : { page: 'positions' };
      this.showShipmentImport = true;
    },
    shipmentScopeIsCurrent() {
      return this.shipmentPageActive && (this.shipmentScope.page !== 'order'
        || String(this.shipmentScope.orderId) === String(this.$route.params.id));
    },
    notifyShipment(text) {
      this.$store.dispatch('notify/addNotify', { text: escapeText(text), error: true });
    },
    onShipmentCompleted(event) {
      if (!event.refreshNeeded || this.shipmentCompletedAttempts.has(event.attemptId)) return;
      this.shipmentCompletedAttempts.add(event.attemptId);
      if (event.uncertain) {
        const text = this.$t('shipmentImportPages.unknown', { id: event.attemptId });
        this.notifyShipment(text);
        if (this.shipmentScopeIsCurrent()) this.shipmentNotice = text;
      }
      if (this.shipmentScopeIsCurrent()) this.refreshShipmentTable();
    },
    onShipmentCleanupError(event) {
      const text = this.$t('shipmentImportPages.cleanupFailed', { id: event.attemptId || '—' }) + ' ' + (event.errors || []).join(' ');
      this.notifyShipment(text);
      if (this.shipmentScopeIsCurrent()) this.shipmentNotice = text;
    },
    async refreshShipmentTable() {
      if (!this.shipmentPageActive || this.shipmentRefreshing) return;
      const route = this.$route.fullPath;
      this.shipmentRefreshing = true;
      try {
        const data = await this.load();
        if (!this.shipmentPageActive || this.$route.fullPath !== route) return;
        if (!data) {
          this.shipmentNotice = this.$t('shipmentImportPages.refreshFailed');
          this.notifyShipment(this.shipmentNotice);
          return;
        }
        // The API clamps an out-of-range page after rows disappear. Keep the URL in sync.
        const page = data.positions_pagination?.page;
        if (page && page !== this.currentPage()) {
          await this.$router.replace({ name: this.$route.name, params: this.$route.params, query: { ...this.$route.query, page } });
        }
      } finally {
        this.shipmentRefreshing = false;
      }
    },
  },
};
